/*! arvea-preorder.js — Pre-Order Launch UI. Auto-hides after 2026-07-31T23:59:59 UTC. */
(function(){
  'use strict';
  if(window.__APO__)return; window.__APO__=true;

  var END = new Date('2026-08-01T00:00:00Z').getTime();
  function alive(){ return Date.now() < END; }
  function isPDP(){ return /\/products\//.test(location.pathname); }
  function isCart(){ return /\/cart/.test(location.pathname); }

  // ── TOP BAR ──────────────────────────────────────────────────────────────
  function topBar(){
    if(!alive()||document.getElementById('arvea-po-bar'))return;
    var el=document.createElement('div'); el.id='arvea-po-bar';
    el.innerHTML='<div class="apb-inner">'
      +'<span class="apb-tag">We&rsquo;re Launching</span>'
      +'<span>Pre-Order Now</span>'
      +'<span class="apb-sep">&middot;</span>'
      +'<span>Ships by End of July</span>'
      +'<span class="apb-sep">&middot;</span>'
      +'<span class="apb-shipping">Free Express Shipping Ends: <span id="apb-timer">--:--:--</span></span>'
      +'</div>';
    document.body.insertBefore(el,document.body.firstChild);
    // ── Countdown to midnight ET ──
    function secToMidnightET(){
      var now=new Date();
      try{
        var etStr=now.toLocaleString('en-US',{timeZone:'America/New_York',hour12:false,hour:'2-digit',minute:'2-digit',second:'2-digit'});
        var m=etStr.match(/(\d+):(\d+):(\d+)/);
        if(m){var h=parseInt(m[1])%24,mi=parseInt(m[2]),s=parseInt(m[3]);return 86400-(h*3600+mi*60+s);}
      }catch(e){}
      return 86400-Math.floor((now.getTime()%(86400000))/1000);
    }
    function fmtTime(sec){
      var h=Math.floor(sec/3600),m=Math.floor((sec%3600)/60),s=sec%60;
      return (h<10?'0':'')+h+':'+(m<10?'0':'')+m+':'+(s<10?'0':'')+s;
    }
    function tickTimer(){var t=document.getElementById('apb-timer');if(t)t.textContent=fmtTime(secToMidnightET());}
    tickTimer();
    setInterval(tickTimer,1000);
  }

  // ── PDP ──────────────────────────────────────────────────────────────────
  function pdp(){
    if(!isPDP()||!alive()||document.getElementById('arvea-po-pdp'))return;
    var block=document.createElement('div'); block.id='arvea-po-pdp';
    block.innerHTML='<div class="apo-title"><span class="apo-dot"></span>Pre-Order &mdash; Ships by End of July 2026</div>'
      +'<div class="apo-row">We&rsquo;re launching Arvea Jewelry. All pre-orders ship by <strong>end of July 2026</strong>.</div>'
      +'<div class="apo-row">Your order is confirmed the moment you check out.</div>';
    var label=document.createElement('div'); label.className='arvea-po-atc-label';
    label.innerHTML='<span class="apl-badge">Pre-Order</span><span>&mdash; Ships End of July</span>';
    var sels=['form[action*="/cart/add"]','.product-form','.product__form','.product-single__form','#ProductSection','.product__info-wrapper','.product__info-container'];
    for(var i=0;i<sels.length;i++){
      var wrap=document.querySelector(sels[i]);
      if(wrap){
        wrap.insertBefore(block,wrap.firstChild);
        var btnSels=['[name="add"]','.btn--add-to-cart','.product-form__submit','.shopify-payment-button','button[type="submit"]'];
        for(var j=0;j<btnSels.length;j++){
          var btn=wrap.querySelector(btnSels[j]);
          if(btn){btn.parentNode.insertBefore(label,btn);break;}
        }
        break;
      }
    }
    if(!document.getElementById('arvea-po-pdp')){
      var h1=document.querySelector('h1');
      if(h1&&h1.parentNode) h1.parentNode.insertBefore(block,h1.nextSibling);
    }
  }

  // ── COLLECTION BADGES ────────────────────────────────────────────────────
  function badges(){
    if(!alive())return;
    var cardSels=['.product-item','.product-card','.grid__item','.grid-product','.card-wrapper','.product-grid-item','li[data-product-id]'];
    var cards=[];
    for(var i=0;i<cardSels.length&&cards.length===0;i++) cards=Array.from(document.querySelectorAll(cardSels[i]));
    cards.forEach(function(c){
      if(c.querySelector('.arvea-po-badge'))return; if(c.closest('.multicolumn-list__item,.multicolumn-card'))return;
      var b=document.createElement('span'); b.className='arvea-po-badge'; b.textContent='Pre-Order';
      var img=c.querySelector('.card__image,.card__media,.product-item__image,.grid-product__image-wrap,.product__media,figure,.product-card__image');
      var tgt=img||c;
      if(getComputedStyle(tgt).position==='static') tgt.style.position='relative';
      tgt.appendChild(b);
    });
  }

  // ── CART NOTICE ──────────────────────────────────────────────────────────
  function cart(){
    if(!isCart()||!alive()||document.getElementById('arvea-po-cart'))return;
    var el=document.createElement('div'); el.id='arvea-po-cart';
    el.innerHTML='<div class="apc-head">Pre-Order &mdash; We&rsquo;re Launching</div>'
      +'<div class="apc-body">Items in your cart are <strong>pre-order</strong>. '
      +'All orders ship by <strong>end of July 2026</strong>. '
      +'You&rsquo;ll receive a shipping confirmation the moment your order is on its way.</div>';
    var sels=['form[action="/cart"]','.cart-form','#CartForm','.cart__items','#cart-items','.cart','main'];
    for(var i=0;i<sels.length;i++){
      var wrap=document.querySelector(sels[i]);
      if(wrap){wrap.insertBefore(el,wrap.firstChild);break;}
    }
  }

  // ── FREE EXPRESS SHIPPING badge in trust strip ───────────────────────────
  function trustBadge(){
    var strip=document.querySelector('.arvea-trust-strip__inner');
    if(!strip||strip.querySelector('.apo-shipping-badge'))return;
    var item=document.createElement('span');
    item.className='arvea-trust-strip__item apo-shipping-badge';
    item.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">'
      +'<rect x="1" y="3" width="15" height="13"/>'
      +'<polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>'
      +'<circle cx="5.5" cy="18.5" r="2.5"/>'
      +'<circle cx="18.5" cy="18.5" r="2.5"/>'
      +'</svg>Free Express Shipping';
    strip.appendChild(item);
  }


  // ── PRICE STRIKETHROUGH ─────────────────────────────────────────────────
  function priceTags(){
    if(!alive())return;
    // Target regular price elements not already processed
    var els=document.querySelectorAll('.price__regular .price-item--regular:not([data-apo-priced])');
    els.forEach(function(el){
      var raw=el.textContent.trim();
      // Parse numeric value — handles "$128.00 USD", "$1,299.00", etc.
      var numMatch=raw.match(/[\d,]+\.?\d*/);
      if(!numMatch)return;
      var val=parseFloat(numMatch[0].replace(/,/g,''));
      if(!val||isNaN(val))return;
      var sale=(val*0.8).toFixed(2);
      // Rebuild with same currency symbol/code
      var prefix=raw.slice(0,raw.search(/[\d]/));
      var suffix=raw.slice(raw.search(/[\d]/)+numMatch[0].length).trim();
      var origFmt=prefix+numMatch[0]+(suffix?' '+suffix:'');
      var saleFmt=prefix+sale+(suffix?' '+suffix:'');
      el.setAttribute('data-apo-priced','1');
      el.classList.add('apo-has-sale');
      el.innerHTML='<s class="apo-orig-price">'+origFmt+'</s>'
        +' <span class="apo-sale-price">'+saleFmt+'</span>'
        +' <span class="apo-pct-badge">-20%</span>';
    });
  }

  // ── INIT ─────────────────────────────────────────────────────────────────
  function run(){
    topBar(); pdp(); cart();
    if(!isPDP()&&!isCart()) badges();
  }

  document.readyState==='loading'
    ? document.addEventListener('DOMContentLoaded',run)
    : run();

  if(typeof MutationObserver!=='undefined'){
    var deb=null;
    new MutationObserver(function(){
      clearTimeout(deb);
      deb=setTimeout(function(){
        if(!isPDP()&&!isCart()) badges();
        if(isPDP()) pdp();
        if(isCart()) cart();
      },400);
    }).observe(document.body,{childList:true,subtree:true});
  }

  // ── OFFER TAB: bottom-right pink pill → opens the 10% signup popup ────────
  // We hide Klaviyo's native flyout (it breaks when clicked — Klaviyo toggles
  // it closed) and replace it with our own pink horizontal tab at bottom-right.
  function offerTab(){
    // ── Suppress ALL Klaviyo flyout/popup elements ──────────────────────────
    // Use setProperty with 'important' so Klaviyo's own inline styles can't win.
    function hideKlaviyoFlyout(){
      try{
        var sels=[
          '[id^="klaviyo-form-"]',
          '.kl-private-reset-css-Xuajs1',
          '.klaviyo-form-main',
          '.needybar',
          '.kl-flyout-tab',
          '.klaviyo-flyout-tab'
        ];
        sels.forEach(function(sel){
          document.querySelectorAll(sel).forEach(function(el){
            el.style.setProperty('display','none','important');
            el.style.setProperty('visibility','hidden','important');
            el.style.setProperty('pointer-events','none','important');
          });
        });
      }catch(e){}
    }
    hideKlaviyoFlyout();
    // Interval: run every 500 ms for the first 15 s to catch late-loading Klaviyo
    var _klCount=0, _klIv=setInterval(function(){
      hideKlaviyoFlyout();
      if(++_klCount>=30) clearInterval(_klIv);
    },500);
    // Also watch for new elements injected by Klaviyo's SDK
    new MutationObserver(function(){ hideKlaviyoFlyout(); })
      .observe(document.body,{childList:true,subtree:false});

    // Don't show if already subscribed
    try{
      var s=JSON.parse(localStorage.getItem('arvea_popup_v2_state')||'{}');
      if(s.subscribed) return;
    }catch(e){}
    if(document.getElementById('arvea-offer-tab')) return;

    var tab=document.createElement('button');
    tab.id='arvea-offer-tab';
    tab.setAttribute('aria-label','Get 10% off — sign up');
    tab.textContent='10% OFF ENTIRE ORDER';
    document.body.appendChild(tab);

    tab.addEventListener('click',function(){
      var overlay=document.getElementById('arvea-popup-overlay');
      if(overlay){
        overlay.classList.add('show');
        try{sessionStorage.setItem('arveaWelcomeShown','1');}catch(e){}
      }
    });

    // Hide tab while popup is open, show when it closes
    var overlay=document.getElementById('arvea-popup-overlay');
    if(overlay){
      new MutationObserver(function(){
        var open=overlay.classList.contains('show');
        tab.style.opacity=open?'0':'1';
        tab.style.pointerEvents=open?'none':'';
      }).observe(overlay,{attributes:true,attributeFilter:['class']});
    }
  }

  setTimeout(offerTab, 1500);

})();